import got from 'got';
import { GetStaticProps } from 'next/types';
import { NextSeo } from 'next-seo';
import Container from '@/giveaway/Container';
import Modals from '@/giveaway/Modals';
import { giveawayProject, giveawayTrack } from '~/constants/eventable';
import GiveawayProviders from '~/context/giveaway/GiveawayProviders';
import { StaticSpinnerData } from '~/contracts/common';
import { ErrorBoundary } from '~/utilities/ErrorBoundary';

type OwnProps = {
  spinnerData: StaticSpinnerData;
};

export default function Giveaway({ spinnerData }: OwnProps) {
  return (
    <>
      <NextSeo
        title="Styled & Dialed Giveaway | Carvana"
        description="Styled & Dialed Giveaway | Carvana"
      />
      <ErrorBoundary>
        <GiveawayProviders
          eventableProject={giveawayProject}
          eventableTrack={giveawayTrack}
        >
          <Container spinnerData={spinnerData} />
          <Modals />
        </GiveawayProviders>
      </ErrorBoundary>
    </>
  );
}

export const getStaticProps: GetStaticProps<OwnProps> = async () => {
  return {
    props: {
      spinnerData: await got
        .get(
          `${process.env.CVNA_APP_SPINNERDATA_BASE_URL}/spinnerdata/9911811097/spinnerData.json`
        )
        .json<StaticSpinnerData>()
    }
  };
};
